/**
 * 统一空状态组件
 */
import React, { memo } from 'react';
import { Empty } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

/**
 * 空状态组件
 * @param {Object} props
 * @param {string} props.title - 标题
 * @param {string} props.description - 描述
 * @param {React.ReactNode} props.action - 操作按钮
 * @param {string} props.type - 类型: 'default' | 'search' | 'error'
 */
const EmptyState = ({
  title = '暂无数据',
  description,
  action,
  type = 'default'
}) => {
  const getIcon = () => {
    switch (type) {
      case 'search':
        return <InboxOutlined style={{ fontSize: 48 }} />;
      case 'error':
        return <InboxOutlined style={{ fontSize: 48 }} />;
      default:
        return <InboxOutlined style={{ fontSize: 48 }} />;
    }
  };

  return (
    <div className="empty-state">
      <div className="empty-state-icon">{getIcon()}</div>
      <div className="empty-state-title">{title}</div>
      {description && (
        <div className="empty-state-description">{description}</div>
      )}
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
};

export default memo(EmptyState);

/**
 * 使用 Ant Design Empty 组件的包装版本
 */
export const EmptyStateAnt = ({
  description = '暂无数据',
  image = Empty.PRESENTED_IMAGE_SIMPLE,
  action
}) => {
  return (
    <Empty
      image={image}
      description={description}
      children={action}
    />
  );
};